/**
 * 工具类方法
 */
import { storage } from "@/utils";
/* 获取相关url配置信息 */
export const getUrlConfig = () => {
  const { hostname } = window.location;
  let zhujiaoDomain = "",
    loginDomain = "", // pcapi接口域名
    stuapiDomain = "",
    pcTeacherDomain = "",
    exportUrl = "";
  switch (hostname) {
    // 生产
    case "ssweb.knowbox.cn": {
      zhujiaoDomain = "https://zhujiao.knowbox.cn";
      loginDomain = "https://ssapinew.knowbox.cn";
      stuapiDomain = "https://stuapi.knowbox.cn";
      pcTeacherDomain = "https://teacher.knowbox.cn";
      exportUrl = "https://fex.knowbox.cn/kb-export/export-pdf";
      break;
    }
    // 预览
    case "pre-ssweb.knowbox.cn": {
      zhujiaoDomain = "https://pre-zhujiao.knowbox.cn";
      loginDomain = "https://pre-ssapinew.knowbox.cn";
      stuapiDomain = "https://pre-stuapi.knowbox.cn";
      pcTeacherDomain = "https://pre-xiaoheschool.knowbox.cn";
      exportUrl = "https://newpdf.pdev.knowbox.cn/kb-export/export-pdf";
      break;
    }
    // 测试
    case "beta-ssweb.knowbox.cn": {
      zhujiaoDomain = "https://beta-zhujiao.knowbox.cn";
      loginDomain = "https://beta-ssapinew.knowbox.cn:9901";
      stuapiDomain = "https://beta-stuapi.knowbox.cn";
      pcTeacherDomain = "https://beta-xiaoheschool.knowbox.cn";
      // zhujiaoDomain = "https://pre-zhujiao.knowbox.cn";
      // loginDomain = " https://pre-ssapinew.knowbox.cn";
      exportUrl = "https://newpdf.pdev.knowbox.cn/kb-export/export-pdf";
      break;
    }
    default: {
      zhujiaoDomain = "https://beta-zhujiao.knowbox.cn";
      loginDomain = "https://beta-ssapinew.knowbox.cn:9901";
      stuapiDomain = "https://beta-stuapi.knowbox.cn";
      pcTeacherDomain = "https://beta-xiaoheschool.knowbox.cn";
      // zhujiaoDomain = "https://pre-zhujiao.knowbox.cn";
      // loginDomain = "https://pre-ssapinew.knowbox.cn";
      // stuapiDomain = "https://pre-stuapi.knowbox.cn";
      // pcTeacherDomain = "https://pre-xiaoheschool.knowbox.cn";
      exportUrl = "https://newpdf.pdev.knowbox.cn/kb-export/export-pdf";
      // zhujiaoDomain = "https://pre-zhujiao.knowbox.cn";
      // loginDomain = " https://pre-ssapinew.knowbox.cn";
      // pcTeacherDomain = "http://192.168.194.55:3000";
      break;
    }
  }
  return {
    loginDomain,
    zhujiaoDomain,
    stuapiDomain,
    pcTeacherDomain,
    exportUrl,
  };
};

/**
 * 动态加载JS/CSS资源
 */
export const loadSrc = (url, domId, type) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error("请设置加载资源的url"));
      return false;
    }
    if (!domId) {
      reject(new Error("请设置加载资源的dom Id"));
      return false;
    }
    if (document.getElementById(domId)) {
      resolve();
    } else {
      if (type === "css") {
        const cssLink = document.createElement("link");
        cssLink.id = domId;
        cssLink.type = "text/css";
        cssLink.rel = "stylesheet";
        cssLink.href = url;
        cssLink.onload = () => {
          resolve();
        };
        document.head.appendChild(cssLink);
      } else {
        const jsScript = document.createElement("script");
        jsScript.id = domId;
        jsScript.type = "text/javascript";
        jsScript.onload = () => {
          resolve();
        };
        jsScript.src = url;
        document.body.appendChild(jsScript);
      }
    }
  });
};

// 页面打开环境检测
export const getBrowserEnv = () => {
  const ua = window.navigator.userAgent;
  return {
    isWeixin: ua.indexOf("MicroMessenger") > -1, // 是否微信环境
    isDD: ua.toLowerCase().indexOf("dingtalk") > -1, // 是否钉钉环境
    isAndroid: ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1, // 是否android终端
    isIOS: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // 是否ios终端
    isWechatMiniProgram: window.__wxjs_environment === "miniprogram", // 是否微信小程序webview环境
    isApp: storage.get("sourceDevice"), // 是否小盒APP内
  };
};
// 获取微信config
export const getWxConfig = () => {
  return {
    // wechatAppId: 13,
    wechatAppId: 9,
    appId: "wx689521122b4e4734", // 小盒课堂公众号
  };
};

// 跳转微信授权
export const redirectWxAuth = (redirectUrl) => {
  const appid = getWxConfig().appId;
  if (!redirectUrl) {
    redirectUrl = `${window.location.origin}${
      import.meta.env.VITE_APP_BASE_URL
    }login?next=${encodeURIComponent(window.location.href)}`;
  }
  const redirect_uri = `https://ssapinew.knowbox.cn/wechat/teacher/auth?next=${encodeURIComponent(
    redirectUrl,
  )}`;
  const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
    redirect_uri,
  )}&response_type=code&scope=snsapi_userinfo&state=qw-course#wechat_redirect`;
  window.location.href = url;
};
// 手机号验证
export const isChinaMobile = (tel) => {
  let fag = false;
  // const reg =
  //   /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/;
  const reg = /^1[0-9]{10}$/; // 1开头11位数字
  fag = reg.test(tel);
  return fag;
};

// 判断页面在 微信 / 微博 / QQ / 支付宝 / 钉钉 内置浏览器内打开
export const isInApp = () => {
  const u = window.navigator.userAgent.toLowerCase();
  const isInApp =
    u.match(/MicroMessenger/i) == "micromessenger" ||
    u.match(/WeiBo/i) == "weibo" ||
    // (u.indexOf("qq") !== -1 && u.indexOf("mqqbrowser") === -1) || // 其中qq浏览器需要特殊处理
    /QQ\/\d/.test(window.navigator.userAgent) ||
    /alipay/gi.test(u) ||
    u.indexOf("dingtalk") !== -1;
  return isInApp;
};

//  钉钉、微信环境设置title
export const setTitle = (title) => {
  let isWx = window.navigator.userAgent.toLowerCase().match("micromessenger");
  if (window.dd.env.platform !== "notInDingTalk") {
    window.dd.ready(() => {
      window.dd.biz.navigation.setTitle({
        title,
      });
    });
  } else if (isWx) {
    document.title = title;
  }
};
// 是否移动端（手机、平板设备）
export const isMobile = () => {
  const isNewIPad =
    /Macintosh/i.test(navigator.userAgent) &&
    "ontouchstart" in document.documentElement &&
    window.matchMedia("(any-pointer:coarse)").matches;
  return /Android|iPhone|Pad|Mobile/i.test(navigator.userAgent) || isNewIPad;
};
/* 根据文件路径获取文件名或后缀名，returnType：name | ext */
export const getFileInfo = (filePath = "", returnType = "ext") => {
  if (returnType === "name") {
    return filePath.replace(/(.*\/)*([^.]+).*/gi, "$2");
  } else if (returnType === "ext") {
    return filePath.replace(/.+\./gi, "");
  }
  return filePath;
};

// 判断是否是微信环境
export const isWx = window.navigator.userAgent
  .toLowerCase()
  .match("micromessenger");

// 校验是否是邮箱
export const isEmail = (email) => {
  return /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email);
};

/*
 *  {token: 1111, userId: 111} 将参数拼接 token=111&userId=111
 */
export const SortParams = (data) => {
  let param = "";
  for (let i in data) {
    if (param) {
      param += `&${i}=${data[i]}`;
    } else {
      param += `${i}=${data[i]}`;
    }
  }
  return param;
};

/**
 * 传入分钟数，返回几天几时几分
 */
export const formatTimeMinute = (minutes = 0) => {
  const days = Math.floor(minutes / (60 * 24)); // 计算天数
  const hours = Math.floor((minutes % (60 * 24)) / 60); // 计算小时数
  const mins = minutes % 60; // 计算分钟数

  let result = "";
  if (days > 0) {
    result += days + "天";
  }
  if (hours > 0) {
    result += hours + "时";
  }
  result += mins + "分钟";

  return result;
};

/**
 *  处理不同环境中跳转逻辑
 * @param {String} url  跳转对应的url
 */
export const goPage = (url) => {
  const { isWechatMiniProgram } = getBrowserEnv();
  //小程序环境
  if (isWechatMiniProgram) {
    wx.miniProgram.navigateTo({ url });
    return;
  }
  //微信 J以及微信外环境
  // location.href = 'weixin://dl/business/?t=nhqWmuanaZm';
  location.href = url;
};
